import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import moment from 'moment';
import '../../stylesheet/dashboard.css'
import AuthNavbar from '../navigation/authnavigation.jsx'
import CardDesign from '../carddesign/carddesign.jsx'
import LeftLink from '../leftlink/leftlink.jsx'

import '../../stylesheet/profilecard.css'
import 'react-toastify/dist/ReactToastify.css';
import $ from 'jquery'
import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
import Loader from '../loader/loader.jsx'
// import noCards from '../../images/noImage.jpg'


const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState,
        display: state.getCardReducer.display,
        profileState: state.getProfileReducer.profileState,
        optionState: state.selectedTabReducer.selectedTabReducer,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        clearInput() {
            dispatch(
                actions.clearInputAction()
            )
        },
        clearProfile() {
            dispatch(
                actions.clearProfileAction()
            )
        }
    })

const JSEncrypt = window.JSEncrypt
class DashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCard: {},

            loader: true,
            useClass: "",
            lastSuccessfulLogin: localStorage.getItem('lastSuccessfulLogin'),
            lastUnsuccessfulLogin: localStorage.getItem('lastUnsuccessfulLogin'),
            // cardState: []
        }
        this.handleCardClick = this.handleCardClick.bind(this)
    }

    handleCardClick(state) {
        this.setState({
            selectedCard: state
        }, () => {
            this.setState({
                useClass: "tile"
            })

            // if (status === "Not Activated") {
            //     this.setState({
            //         useClass: "natile"
            //     })
            // } else if (status === "Activated") {
            //     this.setState({
            //         useClass: "tile"
            //     })
            // } else {
            //     this.setState({
            //         useClass: "cltile"
            //     })
            // }
            document.getElementById("tilediv").style.display = "block"
        })
    }


    getMyMonth(cmonth) {
        if (cmonth === 0) {
            return cmonth = "January"
        } else if (cmonth === 1) {
            return cmonth = "February"
        } else if (cmonth === 2) {
            return cmonth = "March"
        } else if (cmonth === 3) {
            return cmonth = "April"
        } else if (cmonth === 4) {
            return cmonth = "May"
        } else if (cmonth === 5) {
            return cmonth = "June"
        } else if (cmonth === 6) {
            return cmonth = "July"
        } else if (cmonth === 7) {
            return cmonth = "August"
        } else if (cmonth === 8) {
            return cmonth = "September"
        } else if (cmonth === 9) {
            return cmonth = "October"
        } else if (cmonth === 10) {
            return cmonth = "November"
        } else if (cmonth === 11) {
            return cmonth = "December"
        }
    }
    componentWillMount() {
        this.props.fetchPublicKey(false);
        const notProfile = localStorage.setItem("comp", "othercomp")
        const optionstate1 = localStorage.setItem('taboption', 'tab1')

    }
    // componentWillReceiveProps(nextpProps){

    //     if(nextpProps.cardState.status !== 200){
    //         this.setState({
    //             loader:true
    //         })
    //     }
    //     else{
    //         this.setState({
    //             loader:false
    //         })
    //     }
    // }

    componentDidMount() {
        this.props.fetchSelectedTab(localStorage.getItem('taboption'))
        //document.getElementById("tilediv").style.display = "none"

        const { publicKey, cardState } = this.props
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)


            }

        }, 500);

        setTimeout(function () {
            let ele = document.getElementById("firstDiv")
            ele.classList.remove("layoutopac")
        }, 2000)
        // if (time1 < curDate) {

        //     localStorage.clear();
        //     this.props.history.push("/logout")

        // }
    }



    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    getLocalTime = (key) => {

        let local = localStorage.getItem(key)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    getUnLocalTime = (key1) => {

        let local = localStorage.getItem(key1)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    handleLogout(e) {
        localStorage.clear();
        this.props.clearInput()
        this.props.clearProfile()
        this.props.history.push("/logout")

    }

    render() {

        const { selectedCard, useClass, lastSuccessfulLogin, lastUnsuccessfulLogin } = this.state
        const { cardState, profileState, publicKey } = this.props

        // localStorage.setItem("mailingId", profileState.body.mailingInformation.mailingId || null)
        let d = new Date();
        return (
            <div style={{ marginTop: 80 }} id="firstDiv" className="layoutopac">

                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>

                <div className="container" >

                    <div className="row">

                        <div className="col-sm-3 box-shadow-style nopadding" id="leftlink" style={{ minHeight: "470px", }}>
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 15px" }}>
                            {profileState.status === 200 ?
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="greeting-message">
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <div className="header">
                                                        <h3>Hello {profileState.body.firstName}</h3>
                                                        <span>Today is {moment().format('LLLL')}</span>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 " >
                                        <div className="dashboard-well box-shadow-style">
                                            <div className="row" >
                                                <div className="col-md-5 login-success" >
                                                    <label>Last Successful Login  </label>
                                                    {lastSuccessfulLogin !== null && lastSuccessfulLogin !== "null" && lastSuccessfulLogin !== "" &&
                                                        <span> {this.getLocalTime("lastSuccessfulLogin")} </span>}
                                                </div>

                                                <div className="col-md-5 login-fail nopadding" >
                                                    <label>Last Unsuccessful Login  </label>
                                                    {lastUnsuccessfulLogin !== null && lastUnsuccessfulLogin !== "null" && lastUnsuccessfulLogin !== "" &&

                                                        <span> {this.getLocalTime("lastUnsuccessfulLogin")} </span>}
                                                </div>
                                                <div className="col-md-2 text-right" onClick={this.handleLogout.bind(this)}>
                                                    <label><i className="fa fa-sign-out" aria-hidden="true"></i>Logout </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div></div>}
                            <div className="row">
                                <div className="col-sm-12" >
                                    <div className="summary box-shadow-style">
                                        <div className="row " >
                                            <div className="col-sm-12 " >

                                                <div className="dashboard-well">
                                                    <div className="card-summary-header">
                                                        <h4>My Card Summary</h4>
                                                    </div>
                                                </div>
                                            </div>

                                            {cardState.status === 200 ? cardState.body.map((value, i) =>
                                                <div className="col-md-4 col-sm-6 col-lg-6 col-xl-4" onClick={(e) => { this.handleCardClick(cardState.body[i]) }} style={{ cursor: "pointer", marginTop: "10px" }} key={i}>
                                                    <CardDesign name={cardState.body[i].firstName + " " + cardState.body[i].lastName} cardno={cardState.body[i].cardNumber} balance={cardState.body[i].expDate} startwith="4123" />
                                                </div>
                                            ) :
                                                // (cardState.status === 204) ?
                                                //     <div className="offset-3 col-sm-6" >
                                                //         {/* <span style={{fontSize:"20px", fontWeight:"bold", color:"#f13737"}}> {cardState.body}</span> */}
                                                //         <img src={noCards} alt="No Cards" />
                                                //     </div>
                                                //     :
                                                    <div style={{ width: "100%" }}><Loader /></div>
                                            }

                                            <div className="col-sm-12" style={{ padding: "20px" }} >
                                                <div className={useClass + " box-shadow-style animated zoomIn"} id="tilediv" style={{ display: "none" }}>
                                                    <div className="row">
                                                        <div className="col-md-5 col-sm-12">
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Account Name </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername">{selectedCard.firstName + " " + selectedCard.lastName} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Available Balance </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> {selectedCard.availableBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Card Status  </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername">{selectedCard.cardStatus || "NA"} </span><br />
                                                                </div>
                                                            </div>
                                                            {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Credit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.lastCreditPosted || "NA"} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Debit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.lastDebitPosted || "NA"}  </span><br />
                                                                </div>
                                                                </div>*/}
                                                        </div>
                                                        <div className="col-md-7 col-sm-12">
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Ledger Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername">{selectedCard.ledgerBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Credit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername">{selectedCard.lastCreditPosted || "NA"} </span><br />
                                                                </div>
                                                            </div>
                                                            {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Statement Closing Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.lastStatementClosingBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Current Statement Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.currentStatementBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div> */}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <div className="row"> */}




                            {/* </div> */}

                            {/*  */}

                        </div>
                    </div>
                </div>

            </div >
        );
    }
}

DashBoard.defaultProps = {
    cardState: {
        status: 400
    },
    profileState: {
        status: 400
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DashBoard);


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx